module.exports = __webpack_public_path__ + "img/poster-background.4c19ae08.png";